// opervex-frontend/src/components/Financial/ClearingModalProvider.js

import React, { useEffect, useState } from "react";

import ClearingModalComponent from "./ClearingModal";
import ClearingModalService from "./ClearingModalService";

const ClearingModalProvider = () => {
  const [modal, setModal] = useState(null);

  useEffect(() => {
    ClearingModalService.register((options) => {
      return new Promise((resolve) => {
        setModal({
          ...options,
          resolve,
        });
      });
    });

    return () => {
      ClearingModalService.unregister();
    };
  }, []);

  if (!modal) {
    return null;
  }

  const close = (result = null) => {
    modal.resolve(result);
    setModal(null);
  };

  return <ClearingModalComponent {...modal} show={true} onHide={() => close(null)} onConfirm={(result) => close(result)} />;
};

export default ClearingModalProvider;
